// Mínimos de interacción requeridos para habilitar el formulario NPS cuando eligible=true.
// Se cumple mostrar el formulario si se alcanza AL MENOS UNA de estas condiciones:
// NPS_MIN_SEARCHES búsquedas
// O NPS_MIN_FICHA_VIEWS fichas vistas
// O NPS_MIN_LEADS leads enviados
// O NPS_MIN_FAVORITES favoritos agregados
// O NPS_MIN_SHARES veces compartido (fb/twitter/whatsapp/copiar link)
export const NPS_MIN_SEARCHES = 2
export const NPS_MIN_FICHA_VIEWS = 2
export const NPS_MIN_LEADS = 2
export const NPS_MIN_FAVORITES = 2
export const NPS_MIN_SHARES = 2

// El backend recién puede marcar eligible=true una vez que pasaron estos minutos desde
// que se creó el uuid (nps_uuid). Mientras tanto, siempre responde eligible=false.
// El front usa este mismo valor para saber cuánto tiempo puede confiar en un
// eligible=false cacheado antes de volver a consultar /api/nps/eligible.
export const NPS_ELIGIBLE_RECHECK_MINUTES = 24 * 60 // 24 horas */
//export const NPS_ELIGIBLE_RECHECK_MINUTES = 5 // 5 minutos

// Al cerrar el formulario sin responder (onClose), bloqueamos el popup por este tiempo
// las primeras 2 veces que el usuario lo cierra...
export const NPS_CLOSE_RECHECK_MINUTES = 24 * 60 // 24 horas */
//export const NPS_CLOSE_RECHECK_MINUTES = 5 // 5 minutos

// ...y por este tiempo (más largo) a partir de la 3ra vez que lo cierra sin responder.
export const NPS_CLOSE_RECHECK_MINUTES_LONG = 90 * 24 * 60 // 90 días */
//export const NPS_CLOSE_RECHECK_MINUTES_LONG = 10 // 10 minutos
